// ══════════════════════════════════════════════════════════
// CONFIGURATION KO-FI — URLs centralisées
// ══════════════════════════════════════════════════════════

export const KOFI_CONFIG = {
  // Page principale (don ponctuel) — Ko-fi reste pour les tips uniquement.
  // L'abonnement Contributeur Bongo passe par Stripe via la route /soutenir,
  // pas par Ko-fi. C'est pourquoi il n'y a plus de contributorUrl ici.
  coffeeUrl: 'https://ko-fi.com/colobongo',

  // Nom du tier
  tierName: {
    fr: 'Contributeur Bongo',
    en: 'Bongo Contributor'
  },

  // Prix Stripe (mensuel = prix d'appel, annuel = -2 mois offerts).
  // Les chaines pre-formatees sont la source de verite pour l'affichage
  // (locale FR utilise virgule decimale, EN utilise point + $ avant).
  price: {
    monthly: {
      fr: '3,99 $ / mois',
      en: '$3.99 / month',
    },
    yearly: {
      fr: '34,99 $ / an',
      en: '$34.99 / year',
    },
    // Champs bruts pour calculs eventuels — NE PAS utiliser pour l'affichage,
    // utiliser price.monthly[lang] / price.yearly[lang] a la place.
    amount: 3.99,
    yearlyAmount: 34.99,
    currency: 'CAD',
    period: {
      fr: '/mois',
      en: '/month',
    },
  },

  // Limites de scans
  scanLimits: {
    free: 3,
    contributor: 10
  },

  // Limites Frigo (galerie personnelle)
  fridgeLimits: {
    free: 25,
    contributor: 100
  },

  // Limites palettes IA en stock
  paletteStockLimits: {
    free: 20,
    contributor: 50
  },

  // Limites du Carnet de couleurs (projets ACTIFS simultanement)
  // Le quota porte uniquement sur les projets status='active'.
  // Terminer ou supprimer un projet libere immediatement une place.
  coloringProjectLimits: {
    free: 1,
    contributor: 7
  },

  // Cout en scans pour soumettre au Mur — 0 parce que la publication au Mur
  // est INCLUSE dans le scan IA (Analyse IA = 1 scan, qui couvre l'analyse
  // ET le droit de publier sur Le Mur). Pas de double facturation.
  wallSubmissionScanCost: 0
};

export default KOFI_CONFIG;
